import React, { useRef } from "react";
import Icon from "./Icon";
import GallerySectionHeading from "./GallerySectionHeading";
import GalleryLightbox from "./GalleryLightbox";
import useLightbox from "../hooks/useLightbox";
import "../styles/GallerySections.css";
import "../styles/CarouselGallerySection.css";

/*
 * Layout 2 — Horizontal scroll-snap carousel.
 * Uniform cards in a single scrollable row, with arrow buttons that
 * nudge the scroll position (native scroll-snap does the rest).
 */
export default function CarouselGallerySection({ items, eyebrow, heading, sub }) {
  const trackRef = useRef(null);
  const { activeIndex, activeItem, open, close, showPrev, showNext } = useLightbox(items);

  const scrollByAmount = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector(".tp-carousel__card");
    const step = card ? card.offsetWidth + 16 : 280;
    track.scrollBy({ left: direction * step, behavior: "smooth" });
  };

  return (
    <section className="tp-section tp-gallery">
      <div className="tp-container">
        <div className="tp-carousel__header-row">
          <GallerySectionHeading eyebrow={eyebrow} heading={heading} sub={sub} />
          <div className="tp-carousel__controls">
            <button
              type="button"
              className="tp-carousel__arrow"
              aria-label="Scroll left"
              onClick={() => scrollByAmount(-1)}
            >
              <Icon name="chevronLeft" size={20} />
            </button>
            <button
              type="button"
              className="tp-carousel__arrow"
              aria-label="Scroll right"
              onClick={() => scrollByAmount(1)}
            >
              <Icon name="chevronRight" size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="tp-carousel__track" ref={trackRef}>
        {items.map((item, index) => (
          <button
            type="button"
            key={item.id}
            className="tp-carousel__card"
            onClick={() => open(index)}
            aria-label={`View ${item.title} full size`}
          >
            <img src={item.image} alt={item.title} loading="lazy" />
            <span className="tp-carousel__caption">{item.title}</span>
          </button>
        ))}
      </div>

      <GalleryLightbox
        items={items}
        activeIndex={activeIndex}
        activeItem={activeItem}
        onClose={close}
        onPrev={showPrev}
        onNext={showNext}
      />
    </section>
  );
}
